/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreatedQuoteDto } from './CreatedQuoteDto';
import {
    CreatedQuoteDtoFromJSON,
    CreatedQuoteDtoFromJSONTyped,
    CreatedQuoteDtoToJSON,
    CreatedQuoteDtoToJSONTyped,
} from './CreatedQuoteDto';

/**
 * 
 * @export
 * @interface CreateQuoteResponseDto
 */
export interface CreateQuoteResponseDto {
    /**
     * Indicates if the quote creation was successful
     * @type {boolean}
     * @memberof CreateQuoteResponseDto
     */
    isSuccess?: boolean;
    /**
     * Unique identifier of the created quote
     * @type {string}
     * @memberof CreateQuoteResponseDto
     */
    devisId?: string;
    /**
     * Created quotes, each one with the file carrying it
     * @type {Array<CreatedQuoteDto>}
     * @memberof CreateQuoteResponseDto
     */
    quotes?: Array<CreatedQuoteDto>;
    /**
     * Messages of the quotes that could not be created; absent when there are none
     * @type {Array<string>}
     * @memberof CreateQuoteResponseDto
     */
    errors?: Array<string>;
}

/**
 * Check if a given object implements the CreateQuoteResponseDto interface.
 */
export function instanceOfCreateQuoteResponseDto(value: object): value is CreateQuoteResponseDto {
    return true;
}

export function CreateQuoteResponseDtoFromJSON(json: any): CreateQuoteResponseDto {
    return CreateQuoteResponseDtoFromJSONTyped(json, false);
}

export function CreateQuoteResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateQuoteResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'] == null ? undefined : json['isSuccess'],
        'devisId': json['devisId'] == null ? undefined : json['devisId'],
        'quotes': json['quotes'] == null ? undefined : ((json['quotes'] as Array<any>).map(CreatedQuoteDtoFromJSON)),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function CreateQuoteResponseDtoToJSON(json: any): CreateQuoteResponseDto {
    return CreateQuoteResponseDtoToJSONTyped(json, false);
}

export function CreateQuoteResponseDtoToJSONTyped(value?: CreateQuoteResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'devisId': value['devisId'],
        'quotes': value['quotes'] == null ? undefined : ((value['quotes'] as Array<any>).map(CreatedQuoteDtoToJSON)),
        'errors': value['errors'],
    };
}

